import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-radio-group',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, RadioButtonModule],
  template: `
    <div class="flex flex-wrap gap-4">
      @for (opt of options(); track opt.value) {
        <div class="flex items-center gap-2">
          <p-radiobutton
            [name]="config.key"
            [value]="opt.value"
            [formControl]="formControl"
            [inputId]="config.key + '_' + opt.value" />
          <label [for]="config.key + '_' + opt.value" class="cursor-pointer text-sm">
            {{ opt.label }}
          </label>
        </div>
      }
    </div>
  `
})
export class RadioGroupFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }
  options() { return this.config.options ? this.config.options() : []; }
}
